import { faker } from '@faker-js/faker';
import { sample } from 'lodash';

const rules = [...new Array(5)].map(() => ({
  id: faker.datatype.uuid(),
  name: sample(['Inserted Transaction', 'Skimmed Card at ATM', 'Changed Transaction']),
  type: sample(['rule', 'data integrity']),
  date: faker.date.between({ from: '2023-04-01T00:00:00.000Z', to: '2023-05-30T00:00:00.000Z' }),
  acc: sample(['SmartShield']),
  status: sample(['active', 'inactive']),

  channel: sample(['ATM', 'Mobile Banking']),

  amount: faker.finance.amount({ min: 1000, max: 10000, symbol: '$' }),
  severity: sample(['1', '2', '3']),
}));

export default rules;
